import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { CountryService } from '../../shared/services/country.service';
import { ZipCodeService } from '../../shared/services/zip-code.service';
import { map, startWith, delay } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { TypeExpertiseService } from '../../shared/services/type-expertise.service';
import { Expertise } from '../../shared/models/expertise';
import { ExpertiseService } from 'src/app/shared/services/expertise.service';

@Component({
  selector: 'app-expertise-edit',
  templateUrl: './expertise-edit.component.html',
  styleUrls: ['./expertise-edit.component.scss'],
  providers: [ MessageService,TypeExpertiseService ]
})
export class ExpertiseEditComponent implements OnInit, OnChanges {

  @Input() expertise: Expertise;

  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  form: FormGroup;
  items: string[] = ["Noah", "Liam", "Mason", "Jacob"];
  types: any[] = [];
  adrExp: boolean = true;

  constructor(private fb: FormBuilder,
  		private zipCodeService: ZipCodeService,
  	private countryService: CountryService,
    private messageService: MessageService,
    private expertiseService: ExpertiseService,
    
  	) { }

  ngOnInit() {    

  	this._buildForm();
    if (this.expertise.id < 0 && ! this.expertise.number) {
      this.expertiseService.nextNumber().subscribe(n => {
        if (!this.form.value.number) {
          this.form.controls.number.patchValue(n);
        }
      })
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.expertise && changes.expertise.currentValue && changes.expertise.currentValue.errors ) {
      if (Array.isArray(changes.expertise.currentValue.errors)) {
        changes.expertise.currentValue.errors.map(e => {
          this.form.controls[e.field].setErrors({'backend': e.message});
        });
      } else {
        this.messageService.add({severity:'error', summary: 'Erreur', detail: changes.expertise.currentValue.errors});
      }

    }
  }  


  onCancel() {
  	this.cancel.emit();
  }

  onSave() {
    if (!this.form.value.adrExp) {
      this.form.value.address = null;
      this.expertise.address = null;
    }
	console.log(this.expertise, this.form.value);
  	let c = Object.assign((new Expertise()), this.expertise, this.form.value);   

  	this.save.emit(c.toRequest()); 
  }

  _buildForm() {
 	this.form = this.fb.group({
    'number': [ this.expertise.number, [ Validators.required ] ],
 		'name': [ this.expertise.name, [ Validators.required ] ],
    'type': [ this.expertise.type, [  ] ],
    'date_in': [ this.expertise.date_in, [ Validators.required ] ],
    'date_visite': [ this.expertise.date_visite, [ ] ],
    'date_cloture': [ this.expertise.date_cloture, [ ] ],
    'comment': [ this.expertise.comment, [  ] ],
    'adrExp' : [ this.expertise.contact && this.expertise.contact.id != this.expertise.address.id, []],
    'assurance' : [ this.expertise.assurance, []],
    'street': [ this.expertise.street, [  ] ],
    'zip_code': [ this.expertise.zip_code, [  ] ],
    'locality': [ this.expertise.locality, [  ] ],
    'contact': [ this.expertise.contact, [ Validators.required ] ],
    'address': [ this.expertise.address, [ Validators.required ] ],
    'baseUser': [ this.expertise.baseUser, [ Validators.required ] ],
    'satelliteUser': [ this.expertise.satelliteUser, [ Validators.required ] ],
    'collaborateurs': [ this.expertise.collaborateurs, [  ] ],
    });  	
  }

}
